module.exports = __webpack_public_path__ + "static/img/thumb_21.b4e4f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_21.png
// module id = XFTr
// module chunks = 0